// import {useAppDispatch} from "../../../hooks/useTypedReactRedux";


import {
    useAppDispatch,
    useAppSelector
} from "../../../../hooks/useTypedReactRedux.ts";
import {visibilitySelector} from "../selectors";
import {fetchUserProfileAttributes} from "../reducers/recordsSlice.ts";
import {UserProfileAttribute} from "../types.ts";

export const useUserProfileAttributes = () => {

    const dispatch = useAppDispatch();

    const {
        items
    } = useAppSelector((state) => visibilitySelector(state));

    const sub = items.find((item: UserProfileAttribute) => item.name === 'sub')?.value
    const zoneInfo = items.find((item: UserProfileAttribute) => item.name === 'zoneInfo')?.value
    const givenName = items.find((item: UserProfileAttribute) => item.name === 'givenName')?.value
    const familyName = items.find((item: UserProfileAttribute) => item.name === 'familyName')?.value
    const email = items.find((item: UserProfileAttribute) => item.name === 'email')?.value
    const website = items.find((item: UserProfileAttribute) => item.name === 'website')?.value
    const address = items.find((item: UserProfileAttribute) => item.name === 'address')?.value
    const phoneNumber = items.find((item: UserProfileAttribute) => item.name === 'phoneNumber')?.value
    const profile = items.find((item: UserProfileAttribute) => item.name === 'profile')?.value
    const picture = items.find((item: UserProfileAttribute) => item.name === 'picture')?.value
    const locale = items.find((item: UserProfileAttribute) => item.name === 'locale')?.value
    const nickname = items.find((item: UserProfileAttribute) => item.name === 'nickname')?.value
    const accountId = items.find((item: UserProfileAttribute) => item.name === 'accountId')?.value
    const accountAdmin = items.find((item: UserProfileAttribute) => item.name === 'accountAdmin')?.value
    const gender = items.find((item: UserProfileAttribute) => item.name === 'gender')?.value
    const birthDate = items.find((item: UserProfileAttribute) => item.name === 'birthDate')?.value

    const fetchRecords = async () => {
        dispatch(fetchUserProfileAttributes())
    };

    return {
        items,
        sub,
        zoneInfo,
        givenName,
        familyName,
        email,
        website,
        address,
        phoneNumber,
        profile,
        picture,
        locale,
        nickname,
        accountId,
        accountAdmin,
        gender,
        birthDate,
        fetchRecords,
    }
}
